import Link from 'next/link';
import type { ArticleLinkProps } from './types';

const ArticleLink: React.FC<ArticleLinkProps> = ({ article, children }) => {
  const encodedSlug = encodeURIComponent(article.slug);
  return (
    <article key={article.id}>
      <Link href={`/travel-journal/${encodedSlug}`}>
        <a>{children}</a>
      </Link>
    </article>
  );
};

export default ArticleLink;
